import { render, staticRenderFns } from "./KanbanColumn.vue?vue&type=template&id=a7f7f8a2&scoped=true"
import script from "./KanbanColumn.vue?vue&type=script&lang=js"
export * from "./KanbanColumn.vue?vue&type=script&lang=js"
import style0 from "./KanbanColumn.vue?vue&type=style&index=0&id=a7f7f8a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7f7f8a2",
  null
  
)

export default component.exports